import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import HeaderPageForm from './header-component/HeaderPageForm';
import HeaderForGeneral from './header-component/HeaderForGeneral';

export interface HeaderProps {
    headerMobileComponent?: ReactElement,
    headerMobileComponentForGeneral?: ReactElement,
    onlyShowMobile?: boolean,
    isHeaderPageform?: boolean
}

export default observer(function Header({
    isHeaderPageform = false
}: HeaderProps) {
    return (
        <header className='fixed w-screen top-0 left-0 z-[60] bg-white overflow-hidden border-b-2 border-border-gray'>
            {isHeaderPageform ?
                (
                    <div className='px-containerX'>
                        <HeaderPageForm />
                    </div>
                ) :
                <HeaderForGeneral />}

        </header>
    );
});
